import styled from 'styled-components';

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  overflow-y: auto;
  background: rgba(0, 0, 0, 0.1);
  z-index: var(--z-modal);

  padding: 20px;

  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media (min-width: 48em) {
    padding: 0 20px;
  }

  @media (min-width: 64em) {
    padding: 0 100px;
  }
`;

export { ModalBackdrop };
